<template>
  <div class="TmTextEdit">
    <el-tabs :stretch="true" value="style">
      <el-tab-pane
        :label="$t('lcd.Editor.Style')"
        name="style"
        class="style-pane"
      >
        <attr-row
          :label="$t('lcd.Editor.Layer Name') + ' : ' + conf.name"
        ></attr-row>
        <attr-row :label="$t('lcd.Editor.Text Content')">
          <div style="display: flex; justify-content: space-between">
            <el-input
              disabled
              size="mini"
              v-model="conf.text"
              style="width: 49%"
            />
            <el-select
              v-model="conf.datasetField"
              size="mini"
              clearable
              filterable
              :placeholder="$t('lcd.Editor.Please Select Data Feild')"
              style="width: 49%"
            >
              <el-option
                v-for="field in goodsFields"
                :key="field.value"
                :label="field.label"
                :value="field.value"
                :disabled="field.type != 'date'"
              />
            </el-select>
          </div>
          <div style="height: 8px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.preText"
              :placeholder="$t('lcd.Editor.preText')"
              size="mini"
              style="width: 49%"
            />
            <el-input
              v-model="conf.sufText"
              :placeholder="$t('lcd.Editor.sufText')"
              size="mini"
              style="width: 49%"
            />
          </div>
          <div style="height: 8px"></div>
          <!-- 日期格式设置 -->
          <div style="display: flex; justify-content: space-between">
            <el-select v-model="conf.dateFormat" size="mini" style="width: 49%">
              <el-option
                v-for="item in dateFormat"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input
              v-model="conf.dateSeparator"
              :placeholder="$t('lcd.Editor.dateSeparator')"
              size="mini"
              style="width: 49%"
            />
          </div>
          <div style="height: 8px"></div>
          <!-- 时间格式设置 -->
          <div style="display: flex; justify-content: space-between">
            <el-select v-model="conf.timeFormat" size="mini" style="width: 49%">
              <el-option
                v-for="item in timeFormat"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input
              v-model="conf.timeSeparator"
              :placeholder="$t('lcd.Editor.timeSeparator')"
              size="mini"
              style="width: 49%"
            />
          </div>
        </attr-row>
        <attr-row
          class="custom-smaller-btn"
          :label="$t('lcd.Editor.Position and Size')"
        >
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.left"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeX"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">X</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.top"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeY"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">Y</div>
              </template>
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.width"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeW"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">W</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.height"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeH"
            >
              <template slot="prepend"
                ><div style="width: 12px; text-align: center">H</div></template
              >
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div v-if="!pageColor" style="display: flex; align-items: center">
            <i
              class="icon iconfont icon-zitiyanse"
              style="font-size: 12px; margin-right: 6px; color: #000"
            ></i>
            <el-color-picker
              v-model="conf.fontColor"
              show-alpha
              :predefine="predefineColors"
              size="mini"
            />
            <i
              class="icon iconfont icon-beijingse"
              style="font-size: 12px; margin: 0 6px 0 18px; color: #000"
            ></i>
            <el-color-picker
              v-model="conf.bgColor"
              show-alpha
              :predefine="predefineColors"
              size="mini"
            />
          </div>
          <!-- 价签字体颜色 -->
            <div
              class="EditorEslColorList"
              v-if="pageColor"
              style="display: flex; align-items: center"
            >
              <i
                class="icon iconfont icon-zitiyanse"
                style="font-size: 12px; margin-right: 6px; color: #000"
              ></i>
              <i v-for="(c, index) in colorList" :key="c.id">
                <span
                  v-if="c.flag.includes(pageColor)"
                  @click="changeFontColor(index)"
                  class="colorLi"
                  :style="{ background: c.color }"
                ></span>
              </i>
            </div>
            <!-- 价签填充色 -->
            <div
              class="EditorEslColorList"
              v-if="pageColor"
              style="display: flex; align-items: center"
            >
              <i
              class="icon iconfont icon-beijingse"
              style="font-size: 12px; margin-right: 6px; color: #000"
            ></i>
              <i v-for="(c, index) in colorList" :key="c.id">
                <span
                  v-if="c.flag.includes(pageColor)"
                  @click="changeBgColor(index)"
                  class="colorLi"
                  :style="{ background: c.color }"
                ></span>
              </i>
              <img @click="conf.bgColor = 'rgba(0,0,0,0)'" :src="transparentBg" style="width: 18px;height:18px;">
            </div>
          <div style="height: 5px"></div>
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Bold')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.isBold ? 'primary' : ''"
                @click="handleClickBold"
              >
                <i
                  class="icon iconfont icon-zitijiacu"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Italic')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.isItaly ? 'primary' : ''"
                @click="handleClickItaly"
              >
                <i
                  class="icon iconfont icon-zitixieti"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Underline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.isUnderline === 'underline' ? 'primary' : ''"
                @click="handleClickUnderline"
              >
                <i
                  class="icon iconfont icon-zitixiahuaxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Deleteline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.isUnderline === 'line-through' ? 'primary' : ''"
                @click="handleClickDeleteline"
              >
                <i
                  class="icon iconfont icon-zitishanchuxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Left')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'flex-start' ? 'primary' : ''"
                @click="changeTA('flex-start')"
              >
                <i
                  class="icon iconfont icon-zuoduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Center in Horizontal')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'center' ? 'primary' : ''"
                @click="changeTA('center')"
              >
                <i
                  class="icon iconfont icon-chuizhijuzhong"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Right')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'flex-end' ? 'primary' : ''"
                @click="changeTA('flex-end')"
              >
                <i
                  class="icon iconfont icon-youduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align to Top')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'flex-start' ? 'primary' : ''"
                @click="changeVA('flex-start')"
              >
                <i
                  class="icon iconfont icon-shangduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Center in Vertical')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'center' ? 'primary' : ''"
                @click="changeVA('center')"
              >
                <i
                  class="icon iconfont icon-shuipingjuzhong"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align to Bottom')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'flex-end' ? 'primary' : ''"
                @click="changeVA('flex-end')"
              >
                <i
                  class="icon iconfont icon-xiaduiqi"
                  style="font-size: 12px"
                ></i>
              </el-button>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-select v-model="conf.font" size="mini" style="width: 49%">
              <el-option
                v-for="item in allFontList"
                :key="item"
                :label="item"
                :value="item"
                :style="{ fontFamily:item }"
              />
            </el-select>
            <el-select
              v-model="conf.fontSize"
              size="mini"
              filterable
              allow-create
              default-first-option
              style="width: 49%"
            >
              <el-option
                v-for="item in fontSizeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </attr-row>

        <attr-row
          :label="$t('lcd.Editor.Rotate')"
          :height="38"
          class="custom-smaller-slider-btn2"
        >
          <el-slider
            v-model="conf.rotate"
            :min="0"
            :max="360"
            style="margin-left: 10px"
          />
          <el-input-number
            v-model="conf.rotate"
            controls-position="right"
            :min="0"
            :max="360"
            size="mini"
          />
        </attr-row>

        <!-- 显示逻辑 -->
        <attr-row
          :label="$t('lcd.Editor.isShow')"
          class="tt"
          style="position: relative"
        >
          <el-radio-group v-model="conf.hide">
            <el-radio size="mini" :label="true">{{
              $t("lcd.Editor.hide text")
            }}</el-radio>
            <el-radio size="mini" :label="false">{{
              $t("lcd.Editor.show text")
            }}</el-radio>
          </el-radio-group>
          <!-- {{conf.showLogic}} -->
          <el-button
            class="logicBtn"
            type="text"
            size="mini"
            @click.native="showLogicDialog"
            >{{ $t("lcd.Editor.show logic") }}</el-button
          >
        </attr-row>
      </el-tab-pane>
      
    </el-tabs>
    <LogicDialog
      :logicDetail="conf.showLogic"
      ref="logicRef"
      @getLogic="getLogic"
    ></LogicDialog>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import {
  predefineColors,
  colorList,
  fontList,
  fontSizeList,
  dateFormat,
  timeFormat,
} from "../../../utils/constant.js";
import AttrRow from "../../tumeng-attr-row/src/index.vue";
import LogicDialog from "../../tumeng-display/src/index.vue";
import transparentBg from "../../../assets/imgs/icon-tr-bg.png";

export default {
  name: "TumengTimeEdit",
  props: {
    goodsFields: {
      type: Array,
      default: function () {
        return [];
      },
    },
    userFontList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: { AttrRow, LogicDialog },
  data() {
    return {
      isMore: false,
      state: store.state,
      predefineColors,
      colorList,
      allFontList: Array.from(new Set ([...fontList,...JSON.parse(localStorage.getItem('userFontList'))])),
      fontSizeList,
      dateFormat,
      timeFormat,
      transparentBg,
      canvasWidth: store.state.programInfo.width,
      canvasHeight: store.state.programInfo.height,
      Maximum: parseInt(store.state.programInfo.width) >= parseInt(store.state.programInfo.height)
          ? parseInt(store.state.programInfo.width)
          : parseInt(store.state.programInfo.height)
    };
  },
  computed: {
    conf: {
      get() {
        return this.state.activeComponent;
      },
    },
    pageColor() {
      return this.state.programInfo.color ? this.state.programInfo.color : "";
    },
    clipShapObj() {
      return store.state.activeComponent.clipShap || {};
    },
    // goodsFields() {
    //   let fields = null;
    //   console.log(
    //     "=======>>>>>>>>>>",
    //     store.state.programInfo.templateGroupId
    //   );
    //   console.log(
    //     "=======>>>>>>>>>>",
    //     store.state.programInfo.goodsFields
    //   );
    //   if (store.state.programInfo.templateGroupId == 0) {
    //     fields = store.state.programInfo.goodsFields;
    //   }
    //   if (fields) {
    //     return fields;
    //   }
    //   return undefined;
    // },
  },
  methods: {
    changeRangeX(e) {
      console.log("X", e);
      console.log(this.canvasWidth, this.canvasHeight);
      let confX = +e;
      if (this.conf.rotate == 0 || this.conf.rotate == 360) {
        if (confX > this.canvasWidth - this.conf.width) {
          confX = this.canvasWidth - this.conf.width;
        } 
      } else {
        if (confX > this.canvasWidth) {
          confX = this.canvasWidth
        } 
      }
      if (confX < 0 - this.canvasWidth) {
        confX = 0 - this.canvasWidth;
      }
      this.conf.left = confX;
    },
    changeRangeY(e) {
      let confY = +e;
      if (this.conf.rotate == 0 || this.conf.rotate == 360) {
        if (confY > this.canvasHeight - this.conf.height) {
          confY = this.canvasHeight - this.conf.height;
        }
      } else {
        if (confY > this.canvasHeight) {
          confY = this.canvasHeight
        } 
      }
      if (confY < 0 - this.canvasHeight) {
        confY = 0 - this.canvasHeight;
      }
      this.conf.top = confY;
    },
    changeRangeW(e) {
      let confW = +e;
      // if (confW > this.canvasWidth - this.conf.left) {
      //   confW = this.canvasWidth - this.conf.left;
      // }
      if (confW > this.Maximum) {
        confW = this.Maximum;
      }
      if (confW < 0) {
        confW = 0;
      }
      this.conf.width = confW;
    },
    changeRangeH(e) {
      let confH = +e;
      // if (confH > this.canvasHeight - this.conf.top) {
      //   confH = this.canvasHeight - this.conf.top;
      // }
      if (confH > this.Maximum) {
        confH = this.Maximum;
      }
      if (confH < 0) {
        confH = 0;
      }
      this.conf.height = confH;
    },
    changeTA(ta) {
      this.conf.textAlign = ta;
    },
    changeVA(va) {
      this.conf.verticalAlign = va;
    },
    changeName() {
      for (let i = 0; i < this.goodsFields.length; i++) {
        if (this.conf.datasetField === this.goodsFields[i].value) {
          this.conf.name = this.goodsFields[i].label;
          this.conf.text = this.goodsFields[i].label;
        }
      }
    },
    handleClickBold() {
      this.conf.isBold = !this.conf.isBold;
    },
    handleClickItaly() {
      this.conf.isItaly = !this.conf.isItaly;
    },
    handleClickUnderline() {
      const text = this.conf.isUnderline === "underline" ? "none" : "underline";
      this.conf.isUnderline = text;
    },
    handleClickDeleteline() {
      const text =
        this.conf.isUnderline === "line-through" ? "none" : "line-through";
      this.conf.isUnderline = text;
    },
    showLogicDialog() {
      this.$refs.logicRef.open();
      console.log(12333333);
    },
    getLogic(val) {
      console.log(val);
      this.conf.showLogic = val;
    },

    // 修改字体颜色
    changeFontColor(index) {
      this.conf.fontColor = this.colorList[index].color;
    },
    // 修改文本填充色背景色
    changeBgColor(index) {
      this.conf.bgColor = this.colorList[index].color;
    },
    // changeBorderColor
    changeBorderColor(index) {
      this.conf.borderColor = this.colorList[index].color;
    },
  },
};
</script>

<style lang="scss" scoped>
.TmTextEdit {
  margin: 8px;

  .style-pane {
    // 时长样式
    .duration {
      div.el-input-number {
        width: 100%;
      }

      ::v-deep span.el-input-number__decrease,
      ::v-deep span.el-input-number__increase {
        display: none;
      }

      ::v-deep input.el-input__inner {
        padding: 0 15px;
        text-align: justify;
      }
    }

    // 横纵坐标、宽高样式
    @import "../../../assets/style/ltwh";
    // 加粗、倾斜、下划线那一行按钮变小
    .custom-smaller-btn {
      ::v-deep button.el-button {
        padding: 5px 11px;
      }
      ::v-deep .el-button--primary.is-plain:hover {
        background: #ffffff;
        border: 1px solid #dcdfe6;
        color: #606266;
      }
    }

    // 行高的样式
    .custom-smaller-slider-btn {
      // 拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }

      // 指定slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 82px);
        margin-right: 12px;
        float: left;
      }

      // 隐藏数字控制按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      // 隐藏数字输入框的padding
      ::v-deep div.el-input-number div.el-input > input.el-input__inner {
        padding: 0;
      }

      // 指定输入框的宽度
      ::v-deep .el-input-number {
        width: 50px;
        float: left;
        margin-top: 5px;
      }
    }

    // 旋转的样式
    .custom-smaller-slider-btn2 {
      // 拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }

      // 指定slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 82px);
        margin-right: 12px;
        float: left;
      }

      // 隐藏数字控制按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      // 隐藏数字输入框的padding
      ::v-deep div.el-input-number div.el-input > input.el-input__inner {
        padding: 0;
      }

      // 指定输入框的宽度
      ::v-deep .el-input-number {
        width: 60px;
        float: left;
        margin-top: 5px;
      }
    }

    .custom-color-picker {
      ::v-deep span.el-color-picker__icon.el-icon-arrow-down {
        display: none;
      }

      ::v-deep div.el-color-picker__trigger {
        border: none;
      }
    }

    // 滚动方向
    .dir {
      .el-radio {
        margin-right: 5px;

        ::v-deep .el-radio__label {
          padding-left: 2px;
        }
      }
    }
  }

  .explain {
    line-height: 30px;
  }
}
.sizeBtn {
  // flex: 1;
  width: 25px;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ::v-deep .el-button.el-button--mini {
    font-size: 12px !important;
  }
  ::v-deep .el-button {
    height: 14px;
    padding: 0 5px;
    margin: 0;
  }
}
.custom-smaller-slider-btn2 {
  .radius-box {
    ::v-deep .el-slider {
      width: 100% !important;
    }
    ::v-deep .el-input-number {
      float: right !important;
    }
    ::v-deep .el-slider__input {
      width: 60px !important;
    }
    ::v-deep .el-slider__runway.show-input {
      margin-right: 76px !important;
    }
    ::v-deep .el-slider__stop {
      display: none;
    }
    ::v-deep .el-slider__marks-text {
      margin-top: 5px;
    }
  }
}
::v-deep .el-tabs__item.is-active {
  background-color: #f5f7fa !important;
  border-radius: 5px 5px 0 0 !important;
}
// ::v-deep .el-tabs > .el-tabs__header .el-tabs__item.is-active{
//   background-color: #f5f7fa !important;
//   border-radius: 5px 5px 0 0 !important;
// }
.logicBtn {
  position: absolute;
  top: 0px;
  right: -15px;
  z-index: 101;
  &.el-button.el-button--mini {
    font-size: 12px;
  }
}
</style>
